import { Box, media, Stack, styled } from '@migros/msrc-ui-kit';
import React from 'react';
import { Card } from '../../elements/card/Card';
import { FrozenPictogram } from '../../elements/pictograms/FrozenPictogram';
import { ArticleBody, ArticleImage, ArticleLink, ArticleMiniContainer, ArticleMiniImage, StackedBadge } from '../../elements/tiles/partials';
import { ColorVariantsIndicator } from '../../elements/variants';
import { getArticleLink, MINI_TILE_BADGE_OFFSET, MINI_TILE_BADGE_OFFSET_TABLET, TileLayout } from '../../helpers';
import { ConditionalImpressionObserver } from '../../helpers/ConditionalImpressionObserver';
import { ArticleMiniSkeleton } from '../skeleton/ArticleMiniSkeleton';
export const ArticleMini = ({
  mode,
  article,
  heading,
  hideEnergyEfficiency,
  hideDescription,
  hideRating,
  hideBadge,
  linkToFm,
  language,
  loading,
  onClick,
  onImpression,
  customTarget = {}
}) => {
  if (!loading && !!article) {
    const {
      badge_details,
      package_description,
      conditions,
      product_tile_infos,
      badge_discount_image,
      image,
      name,
      price_info,
      no_price_text,
      energy_efficiency,
      ratings,
      accessible_information_text
    } = article;
    const {
      additional_price_info,
      price,
      original_price
    } = price_info || {};
    const {
      price_sub_text
    } = product_tile_infos || {};
    const {
      href,
      anchorTarget
    } = getArticleLink(article, linkToFm, customTarget);
    return /*#__PURE__*/React.createElement(ConditionalImpressionObserver, {
      onImpression: onImpression
    }, /*#__PURE__*/React.createElement(Card, {
      as: "article",
      mode: mode,
      "data-testid": "msrc-articles--article-mini"
    }, /*#__PURE__*/React.createElement(ArticleLink, {
      href: href,
      target: anchorTarget,
      onClick: onClick,
      title: name,
      "aria-label": accessible_information_text,
      "data-testid": "msrc-articles--article-mini-link"
    }, /*#__PURE__*/React.createElement(ArticleMiniContainer, {
      display: ['flex'],
      alignItems: ['center'],
      "aria-hidden": true
    }, /*#__PURE__*/React.createElement(Stack, {
      orientation: "horizontal",
      position: ['relative'],
      alignItems: ['center'],
      size: ['xsmall', 'medium']
    }, image && /*#__PURE__*/React.createElement(ArticleMiniImage, null, /*#__PURE__*/React.createElement(ArticleImage, {
      src: image.src,
      retinaSrc: image.retina_src,
      alt: name
    })), /*#__PURE__*/React.createElement(SizedStack, {
      size: ['xsmall', 'small'],
      badge: !hideBadge && !!badge_discount_image
    }, /*#__PURE__*/React.createElement(ArticleBody, {
      name: name,
      heading: heading,
      layout: TileLayout.mini,
      description: price_sub_text,
      price: price ? additional_price_info ? `${additional_price_info} ${price}` : price : undefined,
      noPriceText: no_price_text,
      originalPrice: original_price,
      mode: mode,
      energyEfficiency: energy_efficiency ? energy_efficiency : undefined,
      hideEnergyEfficiency: hideEnergyEfficiency,
      hideDescription: hideDescription,
      hideRating: hideRating,
      hideBadge: hideBadge,
      badge: badge_details && /*#__PURE__*/React.createElement(StackedBadge, {
        badge_details: badge_details,
        conditions: conditions,
        package_description: package_description,
        language: language,
        horizontal: true
      }),
      ratings: ratings,
      language: language
    }))))), product_tile_infos && product_tile_infos.frozen_pictogram || product_tile_infos && product_tile_infos.has_color_variants ? /*#__PURE__*/React.createElement(Stack, {
      orientation: "horizontal",
      alignItems: "center",
      position: ['absolute'],
      top: ['0'],
      right: ['0']
    }, product_tile_infos && product_tile_infos.has_color_variants ? /*#__PURE__*/React.createElement(Box, {
      marginX: ['small'],
      marginY: ['xsmall', 'xsmall', 'small']
    }, /*#__PURE__*/React.createElement(ColorVariantsIndicator, {
      colorVariantsHint: product_tile_infos && product_tile_infos.color_variants_hint ? product_tile_infos.color_variants_hint : undefined
    })) : undefined, product_tile_infos && product_tile_infos.frozen_pictogram && product_tile_infos.frozen_pictogram.original ? /*#__PURE__*/React.createElement(Box, {
      marginX: ['small'],
      marginY: ['xsmall', 'xsmall', 'small']
    }, /*#__PURE__*/React.createElement(FrozenPictogram, {
      pictogram: product_tile_infos.frozen_pictogram.original
    })) : undefined) : undefined));
  }
  return /*#__PURE__*/React.createElement(ArticleMiniSkeleton, {
    mode: mode
  });
};

// Add a slight offset to balance the empty space in badge graphics
// This must be removed when badges are no longer served as .pngs
const SizedStack = styled(Stack)`
  margin-top: ${({
  badge
}) => badge ? MINI_TILE_BADGE_OFFSET : undefined};

  ${({
  badge
}) => media.tabletWideAndUp`
      margin-top: ${badge ? MINI_TILE_BADGE_OFFSET_TABLET : undefined};
  `}
`;